import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pageable } from '../shared/model/pageable.model';
import { Procedimento } from '../shared/model/procedimento.model';

@Injectable()
export class ProcedimentoService {

  urlBaseProcedimentosApi: string;
  urlBasePrestadoresProcedimentosApi: string;

  constructor(private http: HttpClient) {
    this.urlBaseProcedimentosApi = `${environment.mouraAmmServerURL}/procedimentos`;
    this.urlBasePrestadoresProcedimentosApi = `${environment.mouraAmmServerURL}/prestadores-procedimentos`;
  }

  listarProcedimentos(pageable: Pageable, filtroNome: string): Observable<any> {
    const pageAtual = pageable.page - 1;

    let params = new HttpParams();
    params = params.set('page', pageAtual.toString());
    params = params.set('size', pageable.size.toString());

    if (filtroNome) {
      params = params.set('nome', filtroNome);
    }

    return this.http.get(`${this.urlBaseProcedimentosApi}`, { params });
  }

  listarTodosProcedimentosAtivos(): Observable<any> {
    return this.http.get(`${this.urlBaseProcedimentosApi}/ativos`, {});
  }

  cadastrar(procedimento: Procedimento): Observable<any> {
    return this.http.post<Procedimento>(`${this.urlBaseProcedimentosApi}`, procedimento);
  }

  alterar(procedimento: Procedimento): Observable<any> {
    return this.http.put<Procedimento>(`${this.urlBaseProcedimentosApi}/${procedimento.id}`, procedimento);
  }

  buscar(procedimentoId: number): Observable<any> {
    return this.http.get(`${this.urlBaseProcedimentosApi}/${procedimentoId}`);
  }

  inativar(procedimentoId: number): Observable<any> {
    return this.http.delete(`${this.urlBaseProcedimentosApi}/${procedimentoId}/inativar`);
  }

  ativar(procedimentoId: number): Observable<any> {
    return this.http.put(`${this.urlBaseProcedimentosApi}/${procedimentoId}/ativo`, null);
  }

  listarProcedimentosPorPrestador(usuarioId: number): Observable<any> {
    return this.http.get(`${this.urlBasePrestadoresProcedimentosApi}/por-usuario/${usuarioId}`, {});
  }
}
